import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=3247a7dc&scoped=true"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=3247a7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247a7dc",
  null
  
)

export default component.exports